import { connect, ConnectedProps } from 'react-redux';

import {
  selectors as customersSelectors,
  actions as customersActions,
} from 'src/redux/data/customers';
import { RootState } from 'src/redux/store';

const mapStateToProps = (state: RootState) => ({
  isLoadingForm: customersSelectors.isLoadingForm(state),
  currentCustomer: customersSelectors.selectCurrentCustomer(state),
  customerForm: customersSelectors.selectEditableData(state),
});

const mapActionCreators = {
  createCustomer: customersActions.createCustomer,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
